import { DOOH_REPORT_ADVERTISER } from './config';

const reducer = (state = { data: [{ id: 1, name: "hello" }] }, action) => {
    switch (action.type) {
        case DOOH_REPORT_ADVERTISER:
            return action.payload;

        default:
            return state;
    }
}

export default reducer;